import SubjectContent from '../shared/SubjectContent';
import { finalDesign } from './finalDesign';

export default function MathContent() {
    return <SubjectContent page="math" design={finalDesign} />;
}
